import { useSelector, useDispatch } from "react-redux";
import type { RootState, AppDispatch } from "../rdx/types";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
